import { TextAreaProps } from './TextArea.types';
import './TextArea.scss';
import { ChangeEvent, useEffect, useState } from 'react';
import { normalizeTextInput } from '../general.utils';
export const TextArea: React.FC<TextAreaProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  resizable = false,
  required,
  noNormalize,
}) => {
  const [localValue, setLocalValue] = useState<string>(value || '');

  // set the initial value
  useEffect(() => {
    if (value !== localValue) setLocalValue(value || '');
  }, [localValue, value]);

  /**
   * onChange handler to normalize the input value
   * @param event textarea ChangeEvent
   */
  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    if (noNormalize) {
      onChange(event.target.value);
      setLocalValue(event.target.value);
    } else {
      const value: string = normalizeTextInput(event.target.value);
      onChange(value);
      setLocalValue(value);
    }
  };

  return (
    <div className="textarea-wrapper">
      {label && <p className="textarea-wrapper__label">{label}</p>}
      <textarea
        className={['textarea-wrapper__textarea', disabled ? 'disabled' : ''].join(' ')}
        style={{ resize: resizable ? undefined : 'none' }}
        onChange={handleChange}
        defaultValue={localValue}
        required={required}
        disabled={disabled}
      />
    </div>
  );
};
